import React, { useRef } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

// context
import { useSearchBar } from "core/SearchBar/context/useSearchBar.js";

// styles
import { getBorderStyles } from "../index";
import { regular } from "core/fontStyles";
import colors from "core/colors";
import { convertPxToRem } from "frontend/components/helpers";

export const InputStyled = styled.input`
    flex: 1;
    width: 100%;
    background-color: ${colors.primary.snow};
    height: 100%;
    padding: ${convertPxToRem(10)};
    ${regular}
    font-size: ${convertPxToRem(16)};

    display: flex;
    align-items: center;
    justify-content: center;

    &::placeholder {
        color: ${colors.secondary.bushrock};
    }

    border-radius: 0px;
    border: none;
    border-top: ${({ $borderStyles }) => $borderStyles.border};
    border-bottom: ${({ $borderStyles }) => $borderStyles.border};

    &:focus {
        outline: none;
        border-color: ${({ $borderStyles }) => $borderStyles.focusColor};
    }

    &:hover {
        border-color: ${({ $borderStyles }) => $borderStyles.hoverColor};
    }

    /* overriding Legacy Page Styles */
    &[type=search] {
        box-sizing: border-box;

        &::-webkit-search-cancel-button {
            transform: scale(${({ $scale }) => $scale});
            cursor: pointer;
        }

        /* Hide IOS injected Magnifying Glass */
        &::-webkit-search-decoration {
            display: none;
        }
    }
`;

// component
export const Input = ({ className }) => {
    const {
        isDarkMode,
        inputValue,
        setInputValue,
        clearButtonScale,
        isDisabled,
        inputOnFocus,
        inputOnBlur,
        searchInputRef,
        dropDown: {
            selectedOption: { placeholder }
        }
    } = useSearchBar();

    // Refs
    const defaultInputRef = useRef();
    const inputRef = searchInputRef || defaultInputRef;

    return (
        <InputStyled
            ref={inputRef}
            className={className}
            aria-label={"Search term"}
            name={"q"}
            type={"search"}
            $borderStyles={getBorderStyles(isDarkMode)}
            $scale={clearButtonScale}
            value={inputValue}
            onChange={e => setInputValue(e.target.value)}
            onFocus={inputOnFocus}
            onBlur={inputOnBlur}
            disabled={isDisabled}
            placeholder={placeholder}
        />
    );
};

export default Input;

// prop-types
Input.propTypes = {
    className: PropTypes.string
};
